import { supabase } from "@/lib/supabase.js";

export const uploadAssistantImage = async (assistant, image) => {
  if (!assistant || !image) {
    throw new Error("Assistant and image are required");
  }

  const bucket = "avatars";
  const imageSizeLimit = 6000000; // 6MB

  if (image.size > imageSizeLimit) {
    throw new Error(`Image must be less than ${imageSizeLimit / 1000000}MB`);
  }

  // Log the assistant object to help with debugging

  // Ensure we have valid IDs
  const userId = assistant.user_id || "unknown";

  // Determine the best ID to use for the assistant
  let assistantId;
  if (assistant.id && typeof assistant.id === "string") {
    assistantId = assistant.id;
  } else if (
    assistant.assistant_id &&
    typeof assistant.assistant_id === "string"
  ) {
    assistantId = assistant.assistant_id;
  } else {
    assistantId = "unknown";
  }

  const currentPath = assistant.image_path || "";
  let filePath = `${userId}/assistants/${assistantId}/${Date.now()}`;

  if (currentPath && currentPath.length > 0) {
    try {
      // Check if the old path starts with "assistants/" and adjust it if needed
      let pathToDelete = currentPath;
      if (pathToDelete.startsWith("assistants/")) {
        // Attempt to fix old path format by removing the "assistants/" prefix
        pathToDelete = pathToDelete.substring("assistants/".length);
      }

      const { error: deleteError } = await supabase.storage
        .from(bucket)
        .remove([pathToDelete]);

      if (deleteError) {
        console.error("Error deleting old image:", deleteError);
      }
    } catch (error) {
      console.error("Error during old image deletion:", error);
    }
  }

  const { error } = await supabase.storage
    .from(bucket)
    .upload(filePath, image, {
      upsert: true,
    });

  if (error) {
    console.error("Error uploading image:", error);
    throw new Error("Error uploading image: " + error.message);
  }

  return filePath;
};

export const getAssistantImageFromStorage = async (filePath) => {
  if (!filePath) {
    console.error("No file path provided for assistant image");
    throw new Error("No file path provided for assistant image");
  }

  try {
    // Check if the path starts with "assistants/" and adjust it if needed
    let pathToGet = filePath;
    if (pathToGet.startsWith("assistants/")) {
      // Attempt to fix old path format by removing the "assistants/" prefix
      pathToGet = pathToGet.substring("assistants/".length);
    }

    const { data, error } = await supabase.storage
      .from("avatars")
      .createSignedUrl(pathToGet, 60 * 60 * 24 * 30); // 30 days

    if (error) {
      console.error("Error getting signed URL for assistant image:", error);
      throw new Error("Error downloading assistant image: " + error.message);
    }

    if (!data || !data.signedUrl) {
      console.error("No signed URL returned for assistant image");
      throw new Error("No signed URL returned for assistant image");
    }

    return data.signedUrl;
  } catch (error) {
    console.error("Error getting assistant image from storage:", error);
    throw new Error("Failed to get assistant image URL: " + error.message);
  }
};
